<template>
    <div v-if="isAuth" class="logout-btn" :class="{isFull: 'full'}">
        <button @click="logout" class="btn btn-default">
          <template v-if="isFull">
            Log out
          </template>
          <svg width="24" height="24">
            <use href="/static/images/sprite/sprite.svg#logout-icon"></use>
          </svg>
        </button>
    </div>
    <div v-else class="login-btn">
        <a :href="$getSubdomainLink('portal', '/login')" class="btn btn-default">
          <template v-if="isFull">
            Log in
          </template>
          <svg width="24" height="24">
            <use href="/static/images/sprite/sprite.svg#login-icon"></use>
          </svg>
        </a>
    </div>
</template>

<script>
import { useAuthStore } from "@/stores";
export default {
    props: {
      isFull: {
        type: Boolean,
        default: true
      }
    },
    data() {
        return {
            authStore: useAuthStore(),
        };
    },
    methods: {
        logout() {
            this.authStore.logout();
        },
    },
    computed: {
        isAuth() {
            return this.authStore.isAuth;
        },
    },
};
</script>

<style
  lang="scss"
  scoped
>
.btn {
  display: flex;
  gap:8px;

  .login-btn__icon {
    width: auto;
  }
}
.login-btn {
  &:not(.full) {
    .btn {
      width: max-content;
      margin-left: auto;
    }
  }
}
</style>
